import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Icon} from '@stubhub/bamboo';

import './index.scss';

const Component = ({className = '', onClose, onReset}) => {
  return (
    <div className={`ListingsFilter__Header ${className}`}>
      <button className="ListingsFilter__Header__ResetButton" onClick={onReset} type="button">
        <FormattedMessage defaultMessage="Reset Filters" id="ListingsFilter.resetFilters" />
      </button>
      <button className="ListingsFilter__Header__CloseButton" onClick={onClose} type="button">
        <Icon name="Close" size="sm" />
      </button>
    </div>
  );
};

Component.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onReset: PropTypes.func.isRequired,
};

export default Component;
